module.exports = __webpack_public_path__ + "static/img/z5.437b13b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z5.png
// module id = mg12
// module chunks = 0